import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import StoreIcon from "@NA/Icons/StoreIcon";
import DeliveryTruck from "@NA/Icons/DeliveryTruck";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Img from "@insite/mobius/Img";
import Typography, { TypographyProps, TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import * as React from "react";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors"
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import Truck from "@insite/mobius/Icons/Truck";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CartPageContext } from "@insite/content-library/Pages/CartPage";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Zone from "@insite/client-framework/Components/Zone";
import Button, { ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { StyledButton } from "@insite/mobius/Clickable";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

export interface ProductDetailsShippingCountdownStyles {
    containerStyles?: InjectableCss;
    eachLineStyles?: InjectableCss;
    eachLinePdpStyles?: InjectableCss;
    freeDeliverySpanStyles?: InjectableCss;
    freeDeliveryLableSpanStyles?: InjectableCss;
    orangeColorContainer?: InjectableCss;
    freeDeliveryPopupModal?: ModalPresentationProps;
    freeDeliveryContainerStyles?: TypographyPresentationProps;
    freeDeliveryBtnContainer?: InjectableCss;
    continueButtonContainer?: InjectableCss;
    closeButton?: InjectableCss;
};

const productDetailsShippingCountdownStyles: ProductDetailsShippingCountdownStyles = {
    freeDeliveryPopupModal: {
        headlineTypographyProps: {
            variant: "h2",
            css: css`
                font-size: 28px;
                font-weight: 700;
                font-stretch: normal;
                font-style: normal;
                line-height: 36px;
                letter-spacing: normal;
                color: ${ADIColors.darkBlue1};
                border: 0;
                margin-top: 0;
                margin-bottom: 8px;
                padding-bottom: 0;
            `,
        },

        closeButtonProps: {
            css: css`
                padding: 0;
                margin-top: -60px;
                margin-right: -28px;
                &:hover {
                    background: transparent;
                    border-color: transparent;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary")};
                    width: 35px;
                    height: 35px;
                    > svg {
                        width: 30px;
                        height: 30px;
                        stroke-width: 1.4px;
                    }
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            margin-right: -15px;
                            margin-top: -60px;
                        `,
                        css`
                            margin-right: -15px;
                            margin-top: -40px;
                        `,
                        css`
                            margin-right: -25px;
                            margin-top: -40px;
                        `,
                        null,
                        null,
                    ]);
                }}
            `,
        },
        cssOverrides: {
            headlineTypography: css`
                font-size: 28px;
                line-height: normal;
                margin-bottom: 18px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: 24px;
                                line-height: normal;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            `,
            modalBody: css`
                padding: 34px 27px 27px 27px;
                border-radius: 7px;
                overflow: hidden;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            max-width: calc(100% - 20px);
                            padding: 26px 13px 19px 13px;
                            top: 6%;
                            position: absolute;
                            height: auto;
                            bottom: 5%;
                        `,
                        css`
                            top: 6%;
                            position: absolute;
                            height: auto;
                            max-width: 356px;
                            border-radius: 6px;
                            padding: 26px 13px 19px 13px;
                            bottom: auto;
                        `,
                        css`
                            max-width: 90%;
                            padding: 32px 28px;
                            top: 6%;
                            position: absolute;
                            height: auto;
                        `,
                        css`
                            max-width: 90%;
                            padding: 32px 28px;
                            top: 13%;
                            position: absolute;
                            height: auto;
                        `,
                        css`
                            max-width: 954px;
                            top: 15%;
                            position: absolute;
                            height: auto;
                            margin: 0 auto;
                            padding: 34px 27px 27px 27px;
                        `,
                    ]);
                }}
                ${GridWrapper} {
                    max-width: 100%;
                }
            `,

            modalContent: css`
                padding: 0px;
                overflow: hidden auto;
                &::-webkit-scrollbar {
                    width: 8px;
                }

                &::-webkit-scrollbar-track {
                    background: ${getColor("common.accent")};
                }

                &::-webkit-scrollbar-thumb {
                    background-color: ${ADIColors.lightblue2};
                    // border-radius: 7px;
                }
            `,
            modalTitle: css`
                border: unset;
                padding: 0px 10px 0px 0px;
            `,
        },
    },
    freeDeliveryContainerStyles: {
        css: css`
            padding-right: 15px;
            h5 {
                font-size: 18px;
                font-weight: 700;
                color: #2D2926;
                line-height: 28px;
                margin-bottom: 5px;
                margin-top: 5px
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-bottom: 2px;
                                font-size: 18px;
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
            p {
                font-size: 14px;
                color: #2D2926;
                line-height: 24px;
                margin-bottom: 10px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-bottom: 18px;
                                font-size: 12px;
                                line-height: 1.5;
                            `,
                            css`
                                margin-bottom: 27px;
                                &:first-child {
                                    margin-bottom: 16px;
                                }
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
         
            ${StyledButton} {
                > span {
                    color: ${getColor("primary")}!important;
                }
                &:hover {
                    > span {
                        color: ${getColor("primary")}!important;
                        text-decoration: underline;
                    }
                }
            }
        `,
    },

    freeDeliveryBtnContainer: {
        css: css`
            text-align: right;
            ${ButtonWrapper} {
                min-width: 160px;
                border-radius: 4px;
                span {
                    font-size: 14px;
                    font-weight: 800;
                }
            }
        `,
    },

    containerStyles: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding: 10px 15px;
            border-radius: 4px;
            background-color: ${ADIColors.gray6};
            margin: 14px 0 0 0;
            color: ${ADIColors.darkBlue1};
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
        `,
    },
    eachLineStyles: {
        css: css`
            display: flex;
            gap: 10px;
            align-items: center;
            svg {
                min-width: 16px;
            }
        `,
    },
    eachLinePdpStyles: {
        css: css`
            display: flex;
            gap: 10px;
            align-items: center;
            svg {
                min-width: 16px;
            }
            &:hover {
                text-decoration: underline;
                cursor: pointer;
            }
        `,
    },
    freeDeliverySpanStyles: {
        css: css`
            color: ${ADIColors.orange1} !important;
            text-transform: capitalize;
            &:hover {
                text-decoration: underline;
                cursor: pointer;
            }
        `,
    },
    freeDeliveryLableSpanStyles: {
        css: css`
            text-transform: capitalize;
            &:hover {
                text-decoration: underline;
                cursor: pointer;
            }
        `,
    },
    orangeColorContainer: {
        css: css`
            color: ${ADIColors.orange1} !important;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
        `,
    },
    continueButtonContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                       padding: 20px !important;
                        border-top: 1px solid #bbbbbb;
                        background: #f3f3f3;

                    `, null, null, null, null,
                ], "max")}
        `,
    },
    closeButton: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                      min-height: 21px;
                      padding: 10px 20px;
                       line-height: 21px;
                       border: 1px;              
                       width: 100%;
                    `, null, null, null, null,
                ], "max")}
        `,


    }

}

const mapStateToProps = (state: ApplicationState) => {
    const isAuthenticated = state.context.session!.isAuthenticated;
    const cartState = state.data.carts;
    const cartId = cartState?.currentId || "";
    const cart = cartState?.byId[cartId];
    const billToId = state.context.session.billToId;
    let livechat_accountNumber;
    if (billToId) {
        livechat_accountNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }

    return {
        isAuthenticated,
        session: getSession(state),
        cartId: cartId,
        cart: cart,
        currencySymbol: state.context.session.currency?.currencySymbol ?? "",
        liveChatURL: getSettingsCollection(state).customerSettings.liveChatURL,
        livechat_firstName: state.context.session.firstName,
        livechat_lastName: state.context.session.lastName,
        livechat_email: state.context.session.email,
        livechat_accountNumber,
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer
};

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const ProductDetailsShippingCountdown: React.FC<Props> = ({
    currencySymbol,
    product,
    productInfo,
    isAuthenticated,
    session,
    cartId,
    cart,
    id,
    liveChatURL,
    livechat_firstName,
    livechat_lastName,
    livechat_accountNumber,
    livechat_email,
    toggleLoginDrawer
}) => {
    const [openShippingCountdownModalOpen, setOpenShippingCountdownModalOpen] = React.useState<boolean>(false);
    const styles = productDetailsShippingCountdownStyles;
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    const getCustomerCreditStatus = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
    );
    const thresholdAmt: number = +session?.properties["freeshipThresholdAmt"] | 0;
    let qualifedFreeShip: boolean = false;
    let wantFreeShip: boolean = false;
    let itemQualifyFreeShip: boolean = false;
    let cartValue: number | undefined = cart?.orderSubTotal;
    const unitListPrice = productInfo.pricing?.actualPrice ? productInfo.pricing?.actualPrice : product.unitListPrice;
    let eligibleAmt;

    const closeShippingCountdownModal = () => {
        setOpenShippingCountdownModalOpen(false);
    };

    if (thresholdAmt || thresholdAmt == 0) {
        if (cartValue >= thresholdAmt) {
            qualifedFreeShip = true;
            wantFreeShip = false;
            itemQualifyFreeShip = false;
            localStorage.setItem("IsFreeShip", "Yes");
        }

        if (cartValue < thresholdAmt) {
            qualifedFreeShip = false;
            wantFreeShip = true;
            itemQualifyFreeShip = false;
            eligibleAmt = (thresholdAmt - cartValue).toFixed(2);
            localStorage.setItem("IsFreeShip", "No");
        }

        if (product)
            if (
                (cartValue + unitListPrice >= thresholdAmt && cartValue < thresholdAmt) ||
                (thresholdAmt == 0 && cartValue == 0)
            ) {
                qualifedFreeShip = false;
                wantFreeShip = false;
                itemQualifyFreeShip = true;
                localStorage.setItem("IsFreeShip", "No");
            }
    }
    const [accountPendingVerificatioPDP, setaccountPendingVerificatioPDP] = React.useState<string | null>("O");


    const handleChat = () => {
        if (isAuthenticated) {
            const popup: string = "popUpWindow";
            const popupParam: string =
                "height=551,width=344,left=100,top=100,resizable=false,scrollbars=false,toolbar=false,menubar=no,location=no,directories=no,status=yes";

            if (liveChatURL) {
                const result =
                    liveChatURL +
                    "firstName=" +
                    livechat_firstName +
                    "&lastName=" +
                    livechat_lastName +
                    "&accountNumber=" +
                    livechat_accountNumber?.toString().replace("-", "") +
                    "&email=" +
                    livechat_email;
                window.open(result, popup, popupParam);
                localStorage.setItem("openLiveChat", "false");
            }
        } else {
            localStorage.setItem("openLiveChat", "true");
            toggleLoginDrawer({ loginDrawer: true });
        }
    };

    const isPRRegion = typeof window !== "undefined" && window.location.hostname.endsWith(".pr");

    // const shouldShowShippingInfo =
    //     product.properties["logicBroker"]?.toLowerCase() !== "yes" ||
    //     (qualifedFreeShip && !isPRRegion) ||
    //     (wantFreeShip && !isPRRegion) ||
    //     (itemQualifyFreeShip && !isPRRegion);

    return (
        <>
            {cart && isAuthenticated && !isPendingVerification && !isPRRegion && (
                <StyledWrapper {...styles.containerStyles}>
                    {product.properties["logicBroker"]?.toLowerCase() !== "yes" && (
                        <StyledWrapper
                            {...styles.eachLinePdpStyles}
                            onClick={() => setOpenShippingCountdownModalOpen(true)}
                        >
                            <StoreIcon />
                            <Typography as="span">{translate("Free Store Pickup")}</Typography>
                        </StyledWrapper>
                    )}
                    {qualifedFreeShip && (
                        <StyledWrapper {...styles.eachLineStyles}>
                            <DeliveryTruck />
                            <Typography as="span">
                                {translate("You get ")}
                                <Typography
                                    as="span"
                                    {...styles.freeDeliverySpanStyles}
                                    onClick={() => setOpenShippingCountdownModalOpen(true)}
                                >
                                    {translate("free delivery ")}
                                </Typography>
                                {translate(" ")}
                                {translate("on this order")}
                            </Typography>
                        </StyledWrapper>
                    )}
                    {wantFreeShip && (
                        <StyledWrapper {...styles.eachLineStyles}>
                            <DeliveryTruck />
                            <Typography as="span">
                                {translate("Want ")}
                                <Typography
                                    as="span"
                                    {...styles.freeDeliveryLableSpanStyles}
                                    onClick={() => setOpenShippingCountdownModalOpen(true)}
                                >
                                    {translate("free delivery")}
                                </Typography>
                                ?
                                <Typography as="span" {...styles.orangeColorContainer}>
                                    {translate(" Add")} {currencySymbol}
                                    {eligibleAmt} {translate(" more")}
                                </Typography>
                            </Typography>
                        </StyledWrapper>
                    )}
                    {itemQualifyFreeShip && (
                        <StyledWrapper {...styles.eachLineStyles}>
                            <DeliveryTruck />
                            <Typography as="span">
                                {translate("Add this item for")}
                                {translate(" ")}
                                <Typography
                                    as="span"
                                    {...styles.freeDeliverySpanStyles}
                                    onClick={() => setOpenShippingCountdownModalOpen(true)}
                                >
                                    {translate("free delivery")}   
                                </Typography>
                                {translate(" ")}
                                {translate("on your entire order")}
                            </Typography>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            )}
            <Modal
                isOpen={openShippingCountdownModalOpen}
                handleClose={closeShippingCountdownModal}
                headline={translate("Pickup and Delivery Terms")}
                sizeVariant="medium"
                {...styles.freeDeliveryPopupModal}
            >
                <StyledWrapper {...styles.freeDeliveryContainerStyles}>
                    {thresholdAmt > 0 && (
                        <Typography variant="p">
                            <Typography as="span">
                                {translate("ThresholdContent1")}&nbsp;
                                {currencySymbol}
                                {thresholdAmt}&nbsp;
                                {translate("ThresholdContent2")}
                            </Typography>
                        </Typography>
                    )}
                    {thresholdAmt === 0 &&
                        <Typography as="p">
                            <Typography as="span">
                                {translate("ThresholdContent3ForZeroThresoldValue")}
                            </Typography>
                        </Typography>
                    }
   {thresholdAmt > 0 && (
<Typography variant="h5">{translate("Ship Availability")}</Typography>)}
{thresholdAmt === 0 && (
    <Typography variant="h5">{translate("Shipping Availability")}</Typography>)}

                   {thresholdAmt > 0 &&
                        <Typography variant="p">
                            {translate("ShipAvailabilityContent1")} <br />
                            {translate("ShipAvailabilityContent2")}&nbsp;
                             {translate("ShipAvailabilityContent5")}
                        </Typography>
                    }
                    {thresholdAmt === 0 &&
                        <Typography variant="p">
                            {translate("ShipAvailabilityContent3")}
                            {translate("ShipAvailabilityContent4")}
                        </Typography>
                    }
                    <Typography variant="h5">{translate("Shipping Costs")}</Typography>
                    {thresholdAmt > 0 &&
                        <Typography variant="p">
                            {translate("ShippingCostsContent1")} <Typography as="span">{currencySymbol}{thresholdAmt}</Typography>&nbsp;
                            {translate("ShippingCostsContent2")} &nbsp;<Typography as="span">{currencySymbol}{thresholdAmt}</Typography>
                            {translate("ShippingCostsContent3")}  <br />
                            {translate("ShippingCostsContent4")} <Typography as='span' style={{fontWeight: 700}}> {translate("ShippingCostsContent5")}</Typography>&nbsp;
                            {translate("ShippingCostsContent6")} 
                           
                           
                        </Typography>
                    }
                    {thresholdAmt === 0 &&
                        <Typography variant="p">
                            {translate("ShippingCostsContent5ForZeroThresoldValue")}
                            <br />
                         
                            {translate("ShippingCostsContent6ForZeroThresoldValue")}
                        </Typography>
                    }
                     {thresholdAmt > 0 && (
                                       <Typography variant="h5">{translate("Free Store Pickup Options")}</Typography> )}
                                         {thresholdAmt === 0 && (
                                       <Typography variant="h5">{translate("Free Store Pickup")}</Typography> )}
                                      
                    {thresholdAmt > 0 && <Typography variant="p">
                        {translate("FreeBranchPickupContent1")}
                        {translate("FreeBranchPickupContent2")}&nbsp;
                        {translate("FreeBranchPickupContent3")}

                    </Typography>}

                    {thresholdAmt === 0 && <Typography variant="p">
                        {translate("FreeBranchPickupContent5")}

                    </Typography>}

                    
                    {thresholdAmt > 0 &&
                        <>
                        <Typography variant="h5">{translate("* Exclusions:")}</Typography>



                              <Typography variant="p">
                                                            {translate("Exclusions1")} &nbsp;
                                                            {translate("Exclusions2")}  
                                               
                                                        </Typography>
                                                        <Typography variant="p">
                                                      
                                                            {translate("Exclusions3")} 
                                                        </Typography>
                            
                            
                                                        <Typography variant="p">
                                                            <Link href="/flat_rate_shipping">{translate("Learn more ")}</Link>&nbsp;
                                                            {translate("Exclusions4")}
                                                        </Typography>
                        </>
                    }


                    {thresholdAmt === 0 &&
                        <>
                            <Typography variant="h5">{translate("Exceptions:")}</Typography>
                            <Typography variant="p">

                                {translate("Exclusions5")}
                                {translate("Exclusions6")}

                            </Typography>

                            <Typography variant="p">
                                <Link href="/flat_rate_shipping">{translate("Learn more ")}</Link>&nbsp;
                                {translate("Exclusions7")}
                            </Typography>
                        </>
                    }

                    {thresholdAmt > 0 &&
                        <>
                            <Typography variant="h5">{translate("Questions?")}</Typography>
                            <Typography variant="p">
                                {translate("QuestionsContent1")}&nbsp;
                                <Link onClick={handleChat}>{translate(" chat with us ")}</Link> &nbsp;
                                {translate("QuestionsContent2")}&nbsp;
                            </Typography>
                        </>
                    }
                    {thresholdAmt === 0 &&
                        <>
                            <Typography variant="h5">{translate("Need Help?")}</Typography>
                            <Typography variant="p">
                                {translate("QuestionsContent3")}&nbsp;
                                <Link onClick={handleChat}>{translate(" chat with us ")}</Link> &nbsp;
                                {translate("QuestionsContent2")}&nbsp;
                            </Typography>
                        </>
                    }
                    <StyledWrapper {...styles.freeDeliveryBtnContainer}>
                    {/* <StyledWrapper {...styles.continueButtonContainer}> */}
                        <Button onClick={closeShippingCountdownModal}  >
                            Close
                        </Button>
                    {/* </StyledWrapper> */}
                    </StyledWrapper>
                </StyledWrapper>
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withProduct(ProductDetailsShippingCountdown)),
    definition: {
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext, CartPageContext],
        displayName: "Product Details Shipping Countdown",
    },
};

export default widgetModule;
